import { billToSelectorStyles as styles } from "@insite/content-library/Components/BillToSelector";
import { css } from "styled-components";

styles.customerSelectorToolbar = {
    wideCreateNewAddressButton: {
        css: css`
            display: none;
        `,
    },
};

styles.customerSelector = {
    customerCard: {
        editLink: {
            css: css`
                display: none;
            `,
        },
    },
};
